import { useQuery } from "@tanstack/react-query";
import { getOpportunityComments } from "@/helpers/apis";
import { GET_OPPORTUNITY_COMMENTS } from "../constants";

export const useOpportunityCommentsQuery = (opportunity_id: string, instance_id: number) => {
  return useQuery({
    queryKey: [GET_OPPORTUNITY_COMMENTS, opportunity_id, instance_id],
    queryFn: () => getOpportunityComments(opportunity_id, instance_id),
    enabled: Boolean(opportunity_id) && Number.isFinite(instance_id),
  });
};
